import { STORE_APP_VARIANT } from '../constants/actionTypes'

export const appVariants = {
  DEFAULT: 'default',
  CANCELLED: 'cancelled',
  REDESIGN: 'redesign',
}

export const initialState = {
  variant: appVariants.DEFAULT,
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_APP_VARIANT:
      return Object.assign({}, state, { variant: action.variant })
    default:
      return state
  }
}

export default appReducer
